import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationService } from '@app/services/configuration.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelect2Module } from 'ng-select2';
import { RegisterRoutingModule } from './register-routing.module';
import { RegisterComponent } from './register/register.component';
import { Register2Component } from './register2/register2.component';
import { Register3Component } from './register3/register3.component';
import { Register1Component } from './register1/register1.component';
import { ProfilesModule } from '../profiles/profiles.module';
import { RegisterService } from './register.service';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';

@NgModule({
  declarations: [
	  RegisterComponent,
	  Register2Component,
	  Register3Component,
	  Register1Component
  ],
  imports: [
	  CommonModule,
	  FormsModule,
	  ReactiveFormsModule,
	  RegisterRoutingModule,
	  NgSelect2Module,
	  ProfilesModule,
	  RecaptchaModule,
	  RecaptchaFormsModule
  ],
  providers: [
	  RegisterService,
	  {
		  provide: RECAPTCHA_SETTINGS,
		  useValue: { siteKey:  ConfigurationService.SETTING_CAPTCHA_SITEKEY } as RecaptchaSettings,
	  }
  ]
})
export class RegisterModule { }
